import {Program, FrameBuffer} from '../../beam/index';
import BlurVS from '../shaders/blur-vs.glsl';
import BlurFS from '../shaders/blur-fs.glsl';
import HighpassVS from '../shaders/highpass-vs.glsl';
import HighpassFS from '../shaders/highpass-fs.glsl';
import bloomVS from '../shaders/bloom-vs.glsl';
import bloomFS from '../shaders/bloom-fs.glsl';
import settings from '../settings';

export default class BloomRenderPass {

    constructor(renderer) {
        this.renderer = renderer
        this.blurMaterial = new Program(this.renderer.gl,{
            vertexShader:   BlurVS,
            fragmentShader: BlurFS,
            depthTest: false,
            blend: false,
        });
        this.blurMaterial.name = 'blurMaterial'

        this.highPassMaterial = new Program(this.renderer.gl,{
            vertexShader:   HighpassVS,
            fragmentShader: HighpassFS,
            depthTest: false,
            blend: false,
        });
        this.highPassMaterial.name = 'highPassMaterial'

        this.bloomMaterial = new Program(this.renderer.gl,{
            vertexShader:   bloomVS,
            fragmentShader: bloomFS,
            depthTest: false,
            blend: false,
        });
        this.bloomMaterial.name = 'bloomMaterial'

        this.highpassFrameBuffer = new FrameBuffer(this.renderer.gl, {
            width:  window.innerWidth,
            height: window.innerHeight,
            format: this.renderer.gl.RGBA,
            linear: true,
        });
        this.bloomFrameBuffer = new FrameBuffer(this.renderer.gl, {
            width:  window.innerWidth,
            height: window.innerHeight,
            format: this.renderer.gl.RGBA,
            linear: true,
        });
        this.blurBufferFront1 = new FrameBuffer(this.renderer.gl, {
            width:  (window.innerWidth / 2)>>0,
            height: (window.innerHeight / 2)>>0,
            format: this.renderer.gl.RGB,
            linear: true
        });
        this.blurBufferBack1 = new FrameBuffer(this.renderer.gl, {
            width:  (window.innerWidth / 2)>>0,
            height: (window.innerHeight / 2)>>0,
            format: this.renderer.gl.RGB,
            linear: true
        });
        this.blurBufferFront2 = new FrameBuffer(this.renderer.gl, {
            width:  (window.innerWidth / 4)>>0,
            height: (window.innerHeight / 4)>>0,
            format: this.renderer.gl.RGB,
            linear: true
        });
        this.blurBufferBack2 = new FrameBuffer(this.renderer.gl, {
            width:  (window.innerWidth / 4)>>0,
            height: (window.innerHeight / 4)>>0,
            format: this.renderer.gl.RGB,
            linear: true
        });
        this.blurBufferFront3 = new FrameBuffer(this.renderer.gl, {
            width:  (window.innerWidth / 8)>>0,
            height: (window.innerHeight / 8)>>0,
            format: this.renderer.gl.RGB,
            linear: true
        });
        this.blurBufferBack3 = new FrameBuffer(this.renderer.gl, {
            width:  (window.innerWidth / 8)>>0,
            height: (window.innerHeight / 8)>>0,
            format: this.renderer.gl.RGB,
            linear: true
        });
        this.blurBufferFront4 = new FrameBuffer(this.renderer.gl, {
            width:  (window.innerWidth / 16)>>0,
            height: (window.innerHeight / 16)>>0,
            format: this.renderer.gl.RGB,
            linear: true
        });
        this.blurBufferBack4 = new FrameBuffer(this.renderer.gl, {
            width:  (window.innerWidth / 16)>>0,
            height: (window.innerHeight / 16)>>0,
            format: this.renderer.gl.RGB,
            linear: true
        });

    }

    resize(w, h) {
        this.w = w;
        this.h = h;
        this.highpassFrameBuffer.resize(this.w, this.h)
        this.bloomFrameBuffer.resize(this.w, this.h)
        this.blurBufferFront1.resize(this.w/2, this.h/2)
        this.blurBufferBack1.resize(this.w/2, this.h/2)
        this.blurBufferFront2.resize(this.w/4, this.h/4)
        this.blurBufferBack2.resize(this.w/4, this.h/4)
        this.blurBufferFront3.resize(this.w/8, this.h/8)
        this.blurBufferBack3.resize(this.w/8, this.h/8)
        this.blurBufferFront4.resize(this.w/16, this.h/16)
        this.blurBufferBack4.resize(this.w/16, this.h/16)
    }

    render(bufferScene, bufferPlane, bufferCamera, input, output) {

        //HIGHPASS FILTER
        bufferPlane.material =	this.highPassMaterial ;
        this.highPassMaterial.uniforms.uBloomThreshold.value = settings.uBloomThreshold
        this.highPassMaterial.uniforms.tInput.value =  input
        this.renderer.clearColor(0,0,0,1)
        this.renderer.clear()
        this.renderer.render(bufferScene, bufferCamera, this.highpassFrameBuffer)
        //BLOOM: MIPMAP BLUR
        bufferPlane.material =	this.blurMaterial 
        this.renderer.clearColor(0,0,0,1)
        this.renderer.clear()
        this.blurMaterial.uniforms.uResolution.value  = [this.w/2,this.h/2];
        this.blurMaterial.uniforms.uBlurDirection.value = [settings.uBloomBlur,0]
        this.blurMaterial.uniforms.tInput.value = this.highpassFrameBuffer
        this.renderer.render(bufferScene, bufferCamera, this.blurBufferFront1);
        this.blurMaterial.uniforms.uBlurDirection.value = [0,settings.uBloomBlur]
        this.blurMaterial.uniforms.tInput.value = this.blurBufferFront1
        this.renderer.render(bufferScene, bufferCamera,this.blurBufferBack1);
        this.blurMaterial.uniforms.uResolution.value  = [this.w/4,this.h/4];
        this.blurMaterial.uniforms.uBlurDirection.value = [settings.uBloomBlur,0]
        this.blurMaterial.uniforms.tInput.value = this.blurBufferBack1
        this.renderer.render(bufferScene, bufferCamera, this.blurBufferFront2);
        this.blurMaterial.uniforms.uBlurDirection.value = [0,settings.uBloomBlur]
        this.blurMaterial.uniforms.tInput.value = this.blurBufferFront2
        this.renderer.render(bufferScene, bufferCamera,this.blurBufferBack2);
        this.blurMaterial.uniforms.uResolution.value  = [this.w/8,this.h/8];
        this.blurMaterial.uniforms.uBlurDirection.value = [settings.uBloomBlur,0]
        this.blurMaterial.uniforms.tInput.value = this.blurBufferBack2
        this.renderer.render(bufferScene, bufferCamera, this.blurBufferFront3);
        this.blurMaterial.uniforms.uBlurDirection.value = [0,settings.uBloomBlur]
        this.blurMaterial.uniforms.tInput.value = this.blurBufferFront3
        this.renderer.render(bufferScene, bufferCamera,this.blurBufferBack3);
        this.blurMaterial.uniforms.uResolution.value  = [this.w/16,this.h/16];
        this.blurMaterial.uniforms.uBlurDirection.value = [settings.uBloomBlur,0]
        this.blurMaterial.uniforms.tInput.value = this.blurBufferBack3
        this.renderer.render(bufferScene, bufferCamera, this.blurBufferFront4);
        this.blurMaterial.uniforms.uBlurDirection.value = [0,settings.uBloomBlur]
        this.blurMaterial.uniforms.tInput.value = this.blurBufferFront4
        this.renderer.render(bufferScene, bufferCamera,this.blurBufferBack4);
        //reset resolution
        //BLOOM: MERGE
        bufferPlane.material =	this.bloomMaterial 
        if (this.bloomMaterial.uniforms.uResolution)
            this.bloomMaterial.uniforms.uResolution.value = [this.w,this.h];
        if (this.bloomMaterial.uniforms.uBloomAmount)
            this.bloomMaterial.uniforms.uBloomAmount.value = settings.uBloomAmount
        if (this.bloomMaterial.uniforms.tBlur1)
            this.bloomMaterial.uniforms.tBlur1.value = this.blurBufferBack1
        if (this.bloomMaterial.uniforms.tBlur2)
            this.bloomMaterial.uniforms.tBlur2.value = this.blurBufferBack2
        if (this.bloomMaterial.uniforms.tBlur3)
            this.bloomMaterial.uniforms.tBlur3.value = this.blurBufferBack3
        if (this.bloomMaterial.uniforms.tBlur4)
            this.bloomMaterial.uniforms.tBlur4.value = this.blurBufferBack4
        if (this.bloomMaterial.uniforms.tBloomInput)
            this.bloomMaterial.uniforms.tBloomInput.value = input
        bufferPlane.id = 'BloomPass'
        bufferPlane.name = 'BloomPass'
        this.renderer.render(bufferScene, bufferCamera, this.bloomFrameBuffer);

        this.renderer.clearColor(0,0,0,1)
        this.renderer.clear()
        this.renderer.render( bufferScene, bufferCamera, output );
    }

}